<template>
    <div>
        <div class="file-list-item-wrapper">
            <div>
                {{ $t('resourcesInternal.resourceTypeHeader') }}
            </div>
            <div>
                {{ $t('resourcesInternal.resourceTitleHeader') }}
            </div>
            <div>
                {{ $t('resourcesInternal.resourcePublishDateHeader') }}
            </div>
            <div></div>
        </div>
        <hr style="border-bottom: #f3f3f3; margin:0;" />
    </div>
</template>

<script>
export default {
    name: 'FileListHeader',
    props: {
        fileType: String,
        title: String,
        published: String,
        link: String,
    },
};
</script>

<style scoped>
.file-list-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 5fr 4fr 3fr;
    grid-gap: 10px;
    padding: 10px;
    font-size: 14px;
    background-color: var(--secondary);
    color: white;
}
</style>
